import { normalizeFetchLayersGroupReportResponse } from './utils/normalizers/group.normalizers'
import {
    onDeleteGroupQueryStarted,
    onMoveGroupSubmissionsQueryStarted,
} from './utils/response-handlers/group.api.response-handlers'
import { COMPONENT_TAG, GROUP_TAG } from './utils/tags'
import baseApi from './base.api'

export const groupApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        fetchLayersGroupReport: builder.query({
            query: ({ token }) => ({
                url: `/clusters/${token}/get-layer-clusters-report`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchLayersGroupReportResponse,
            providesTags: [
                { type: COMPONENT_TAG, id: 'LIST' },
                { type: GROUP_TAG, id: 'LIST' },
            ],
        }),
        moveGroupSubmissions: builder.mutation({
            query: ({ token, layerId, submissionIds, targetGroupId, newGroupName }) => ({
                url: `/clusters/${token}/${layerId}/move-cluster-files`,
                method: 'POST',
                body: {
                    files: submissionIds,
                    cluster_id: targetGroupId,
                    cluster_name: newGroupName,
                },
            }),
            onQueryStarted: onMoveGroupSubmissionsQueryStarted,
        }),
        deleteGroup: builder.mutation({
            query: ({ token, layerId, groupId }) => ({
                url: `/clusters/${token}/${layerId}/${groupId}`,
                method: 'DELETE',
            }),
            onQueryStarted: onDeleteGroupQueryStarted,
            invalidatesTags: [{ type: GROUP_TAG, id: 'LIST' }],
        }),
    }),
})

export const { useFetchLayersGroupReportQuery, useMoveGroupSubmissionsMutation, useDeleteGroupMutation } = groupApi
